import { render, staticRenderFns } from "./Counters.vue?vue&type=template&id=2c308202&scoped=true&"
import script from "./Counters.vue?vue&type=script&lang=js&"
export * from "./Counters.vue?vue&type=script&lang=js&"
import style0 from "./Counters.vue?vue&type=style&index=0&id=2c308202&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c308202",
  null
  
)

export default component.exports